import React from 'react';

const variants = {
  primary: "bg-brand-primary text-white hover:bg-brand-hover focus:ring-brand-hover",
  secondary: "bg-gray-200 text-brand-primary hover:bg-brand-hover hover:text-white focus:ring-brand-hover",
  outline: "border-2 border-brand-primary text-brand-primary hover:bg-brand-hover hover:text-white hover:border-brand-hover focus:ring-brand-hover",
  ghost: "text-brand-primary hover:bg-brand-hover hover:text-white focus:ring-brand-hover",
  danger: "bg-red-600 text-white hover:bg-brand-hover focus:ring-brand-hover",
};

const sizes = {
  xs: "px-2 py-1 text-xs",
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
};

const Button = ({
  children,
  type = "button",
  className = "",
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  onClick,
  ...props
}) => {
  const baseStyles = "inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 focus:outline-none  disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-brand-primary";
  
  const LoadingSpinner = () => (
    <svg 
      className="animate-spin -ml-1 mr-2 h-4 w-4" 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24"
    >
      <circle 
        className="opacity-25" 
        cx="12" 
        cy="12" 
        r="10" 
        stroke="currentColor" 
        strokeWidth="4"
      />
      <path 
        className="opacity-75" 
        fill="currentColor" 
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );

  return (
    <button
      type={type}
      className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${loading ? 'cursor-wait' : ''}
        ${className}
        active:bg-brand-hover
        active:scale-95
      `}
      disabled={disabled || loading}
      onClick={loading ? undefined : onClick}
      {...props}
    >
      {loading ? (
        <>
          <LoadingSpinner />
          <span>Loading...</span>
        </>
      ) : (
        <>
          {leftIcon && <span className="mr-2">{leftIcon}</span>}
          {children}
          {rightIcon && <span className="ml-2">{rightIcon}</span>}
        </>
      )}
    </button>
  );
};

export default Button;